// tslint:disable-next-line:max-line-length
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, HostListener, ElementRef, ViewChild, OnInit } from '@angular/core';
import { CellEditType } from '../Grid/CellEditType';
import { SortDirection } from '../Grid/sortDirection.enum';
import { IColumn } from '../Grid/column.interface';
import { ICustomer } from './customer.class';
import { CustomerService } from '../../services/customer.service';
import { CellFocusEvent } from '../Grid/cellFocus.event';
import { ICellChangedEvent } from '../Grid/cellValueChanged.event';

@Component({
    selector: 'app-customer-list',
    templateUrl: 'customerList.component.html',
    styleUrls: ['customerList.component.css']
})

export class CustomerListComponent implements OnChanges, OnInit
{

    columns: IColumn[] = [];
    customers: ICustomer[];
    customer: ICustomer;
    height = 500;
    loading = false;

    @Input() selectedCustomer: ICustomer;
    @Output() customerSelect = new EventEmitter<ICustomer>();

    @ViewChild('title') title: ElementRef;

    constructor(private el: ElementRef, private customerService: CustomerService)
    {

    }

    @HostListener('window:resize', ['$event'])
    onResize()
    {

        this.height = this.el.nativeElement.clientHeight - this.title.nativeElement.clientHeight;
    }

    onCellFocus(e: CellFocusEvent)
    {
        e.proceed();
    }

    onCellChanged(e: ICellChangedEvent) 
    {
        let pub: ICustomer = e.row;
        for (let index = 0; index < this.customers.length; index++)
        {
            let element = this.customers[index];
            element.hasChanged = true;
            break;
        }
    }
    
    setColumns()
    {
        this.columns.length = 0;
        this.columns.push({
            header: 'Customer',
            field: 'customerId',
            canResize: true,
            width: 100,
            cellType: CellEditType.None,
            headerClass: ['table-header'],
            cellClass: ['table-cell'],
            canFilter: false,
            canSort: true,
            sortDirection: SortDirection.Ascending
        });
        this.columns.push({
            header: 'System ID',
            field: 'systemId',
            canResize: true,
            width: 100,
            cellType: CellEditType.None,
            headerClass: ['table-header'],
            cellClass: ['table-cell'],
            canFilter: true,
            canSort: true
        });
        this.columns.push({
            header: 'Name',
            field: 'name',
            canResize: true,
            width: 300, 
            cellType: CellEditType.Text,
            headerClass: ['table-header'],
            cellClass: ['table-cell'],
            canFilter: true,
            canSort: true
        });        this.columns.push({
            header: 'Password',
            field: 'password',
            canResize: true,
            width: 100,
            cellType: CellEditType.Text,
            headerClass: ['table-header'],
            cellClass: ['table-cell'],
            canFilter: false,
            canSort: false
        });
        this.columns.push({
            header: 'EMail',
            field: 'email',
            canResize: true,
            width: 100,
            cellType: CellEditType.Text,
            headerClass: ['table-header'],
            cellClass: ['table-cell'],
            canFilter: false,
            canSort: false
        });
        this.columns.push({
            header: 'Credit Limit',
            field: 'creditLimit',
            canResize: true,
            width: 100,
            cellType: CellEditType.Number,
            headerClass: ['table-header'],
            cellClass: ['table-cell', 'numeric'],
            canFilter: false,
            canSort: false
        });
        this.columns.push({
            header: 'Balance',
            field: 'balance',
            canResize: true,
            width: 100,
            cellType: CellEditType.Number,
            headerClass: ['table-header'],
            cellClass: ['table-cell', 'numeric'],
            canFilter: false,
            canSort: false
        });
        this.columns.push({
            header: 'Max Binds',
            field: 'maxBinds',
            canResize: true,
            width: 100,
            cellType: CellEditType.Number,
            headerClass: ['table-header'],
            cellClass: ['table-cell', 'numeric'],
            canFilter: false,
            canSort: false
        });
        this.columns.push({
            header: 'Msg/sec',
            field: 'maxMsgPerSec',
            canResize: true,
            width: 100,
            cellType: CellEditType.Number,
            headerClass: ['table-header'],
            cellClass: ['table-cell', 'numeric'],
            canFilter: false,
            canSort: false
        });
        this.columns.push({
            header: 'Transient Results',
            field: 'requireTransientResults',
            canResize: true,
            width: 100,
            cellType: CellEditType.YesNo,
            headerClass: ['table-header'],
            cellClass: ['table-cell'],
            canFilter: false,
            canSort: false
        });
        this.columns.push({
            header: 'Test Account',
            field: 'testAccount',
            canResize: true,
            width: 100,
            cellType: CellEditType.YesNo,
            headerClass: ['table-header'],
            cellClass: ['table-cell'],
            canFilter: false,
            canSort: false
        });

    }

    canDrag()
    {
        return false;
    }

    ngOnInit()
    {
        this.setColumns();
        this.customerService.getCustomers()
            .then(customers =>
            {
                this.customers = customers;
            });
    }

    ngOnChanges(changes: SimpleChanges)
    {
    }

    formatCell(col: IColumn, row: ICustomer): string
    {
        return row[col.field];
    }


    onRowClicked(customer: ICustomer)
    {
        this.customer = customer;
        this.customerSelect.emit(this.customer);
    }

    onCustomer(customer: ICustomer)
    {
        this.customer = customer;
        this.customerSelect.emit(this.customer);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Customer/customerList.component.ts